import { lazy } from 'solid-js'
import { messages } from '../../pages/verification-page/verification-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/verification-page/verification-page.jsx')),
    path: '/property/:property_id/verify',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
